/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Orders_In_This_CategoryInputs */

const en_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No orders in this category.`)
};

const es_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay pedidos en esta categoría.`)
};

const fr_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune commande dans cette catégorie.`)
};

const de_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Bestellungen in dieser Kategorie.`)
};

const ja_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このカテゴリにはまだ注文がありません。`)
};

const zh_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此类别下暂无订单。`)
};

const ar_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد طلبات في هذه الفئة.`)
};

const id_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada pesanan di kategori ini.`)
};

const it_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun ordine in questa categoria.`)
};

const ru_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этой категории нет заказов.`)
};

const pt_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum pedido nesta categoria.`)
};

const ko_no_orders_in_this_category = /** @type {(inputs: No_Orders_In_This_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 카테고리에 주문이 없습니다.`)
};

/**
* | output |
* | --- |
* | "No orders in this category." |
*
* @param {No_Orders_In_This_CategoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_orders_in_this_category = /** @type {((inputs?: No_Orders_In_This_CategoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Orders_In_This_CategoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_orders_in_this_category(inputs)
	if (locale === "es") return es_no_orders_in_this_category(inputs)
	if (locale === "fr") return fr_no_orders_in_this_category(inputs)
	if (locale === "de") return de_no_orders_in_this_category(inputs)
	if (locale === "ja") return ja_no_orders_in_this_category(inputs)
	if (locale === "zh") return zh_no_orders_in_this_category(inputs)
	if (locale === "ar") return ar_no_orders_in_this_category(inputs)
	if (locale === "id") return id_no_orders_in_this_category(inputs)
	if (locale === "it") return it_no_orders_in_this_category(inputs)
	if (locale === "ru") return ru_no_orders_in_this_category(inputs)
	if (locale === "pt") return pt_no_orders_in_this_category(inputs)
	return ko_no_orders_in_this_category(inputs)
});